<script setup>
import { toRefs } from 'vue'

const props = defineProps({
  label: {
    type: String
  },
  name: {
    type: String
  },
  value: {
    type: [String, Number]
  },
  modelValue: {
    type: [Boolean, String, Number]
  },
  required: {
    type: Boolean
  },
  disabled: {
    type: Boolean
  }
})

const { label, name, value, modelValue, required, disabled } = toRefs(props)
</script>
<template>
  <label class="flex items-center gap-2 text-lg">
    <input
      type="checkbox"
      :name="name"
      :value="value"
      :checked="modelValue === value"
      @change="$emit('update:modelValue', $event.target.value)"
      class="checkbox border-green-600 [--chkbg:theme(colors.green.600)] [--chkfg:white]"
      :required="required"
      :disabled="disabled"
    />
    <span v-if="label">{{ label }}</span>
  </label>
</template>
<style lang="scss" scoped></style>
